import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, ArrowLeft } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export default function Register(): React.JSX.Element {
    const { t } = useLanguage();
    return (
        <div className="min-h-screen flex flex-col" style={{ background: 'hsl(32 38% 97%)' }}>

            {/* ── Top brand band ── */}
            <div
                className="relative flex-shrink-0 flex flex-col items-center justify-end pb-20 pt-16"
                style={{ background: 'var(--gradient-primary)', minHeight: '20vh' }}
            >
                {/* Wave bottom */}
                <div
                    className="pointer-events-none absolute bottom-0 left-0 right-0 h-12"
                    style={{ background: 'hsl(32 38% 97%)', borderRadius: '50% 50% 0 0 / 100% 100% 0 0' }}
                />
                {/* Logo */}
                <div
                    className="relative flex h-[76px] w-[76px] items-center justify-center rounded-[22px] shadow-2xl mb-4"
                    style={{ background: 'rgba(255,255,255,0.22)', backdropFilter: 'blur(12px)', border: '1.5px solid rgba(255,255,255,0.35)' }}
                >
                    <img src="/logo-only.png" alt="Hadir" className="h-11 w-11 object-contain drop-shadow-sm" />
                </div>
                <h1 className="text-[26px] font-black text-white tracking-tight">{t.loginTitle}</h1>
                <p className="text-[13px] text-white/65 mt-0.5 font-medium">{t.loginSubtitle}</p>
            </div>

            {/* ── Content area ── */}
            <div className="flex-1 flex flex-col px-6 pt-4 pb-10 max-w-sm w-full mx-auto animate-fade-in">

                {/* Info card */}
                <div className="bg-white rounded-2xl border border-border/60 shadow-sm p-6 text-center">
                    <div
                        className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl"
                        style={{ background: 'hsl(var(--primary) / 0.1)' }}
                    >
                        <ShieldCheck className="h-7 w-7 text-primary" />
                    </div>
                    <h2 className="text-[18px] font-black text-foreground mb-2">Account Access</h2>
                    <p className="text-[13px] text-muted-foreground leading-relaxed mb-1">
                        Employee accounts are managed by HR administrators. Self-registration is not available.
                    </p>
                    <p className="text-[13px] text-muted-foreground leading-relaxed">
                        Please contact your HR department to have your account created or to reset your credentials.
                    </p>
                </div>

                {/* Back button */}
                <Link
                    to="/login"
                    className="mt-5 w-full h-12 rounded-xl text-[15px] font-black text-white flex items-center justify-center gap-2 transition-all active:scale-[0.98]"
                    style={{ background: 'var(--gradient-primary)', boxShadow: '0 4px 18px rgba(217,90,20,0.38)' }}
                >
                    <ArrowLeft className="h-4 w-4" />
                    Back to Sign In
                </Link>

                <p className="mt-auto pt-8 text-center text-[11px] text-muted-foreground/60">
                    {t.developedBy}{' '}
                    <a href="https://eltera.id" target="_blank" rel="noopener noreferrer" className="font-bold hover:text-muted-foreground transition-colors">
                        Eltera
                    </a>
                </p>
            </div>
        </div>
    );
}

